import type { CSSProperties } from 'react';

import { fieldStyle } from '../components/dashboards/primitives/field-style';

/** The look of the select. `default` keeps the Tailwind classes it has always
 *  had; `dashboards` uses `--nb-*` tokens inline, which the dashboards button
 *  reset cannot strip and which follow the theme. */
export type RegionTreeVariant = 'default' | 'dashboards';

export function triggerStyle(
  variant: RegionTreeVariant,
  invalid: boolean,
): CSSProperties | undefined {
  if (variant !== 'dashboards') return undefined;
  return fieldStyle(invalid ? 'error' : undefined, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    textAlign: 'left',
    cursor: 'pointer',
  });
}

export function panelStyle(variant: RegionTreeVariant): CSSProperties | undefined {
  if (variant !== 'dashboards') return undefined;
  return {
    background: 'var(--nb-bg)',
    color: 'var(--nb-ink)',
    border: '1px solid var(--nb-border-2)',
    boxShadow: '0 8px 24px rgba(0,0,0,.18)',
  };
}

export function rowStyle(
  variant: RegionTreeVariant,
  depth: number,
  selected: boolean,
): CSSProperties {
  const indent = { paddingLeft: `${8 + depth * 16}px` };
  if (variant !== 'dashboards') return indent;
  return {
    ...indent,
    background: selected ? 'var(--nb-primary-soft)' : 'transparent',
    color: selected ? 'var(--nb-primary)' : 'var(--nb-ink)',
  };
}
